import request from '../request'

export const getZbMilestonesApi = (projectID: number | string): Promise<API.MilestoneZb.Item[]> =>
  request.get(`/workbenchApi/projects/${projectID}/zb-milestones`)

export const createZbMilestoneApi = (projectID: number | string, data: {
  name: string
  planDate: string
  percentage: number
  sortOrder: number
  // Optional milestone code (trimmed server-side, max 64 chars, unique per
  // engineering code when non-empty). opProjectID / opUserID are never sent:
  // the backend derives them from the path and the JWT respectively.
  milestoneCode?: string
}): Promise<API.MilestoneZb.Item> => request.post(`/workbenchApi/projects/${projectID}/zb-milestones`, data)

export const updateZbMilestoneApi = (projectID: number | string, milestoneID: number, data: {
  planDate?: string
  actualDate?: string
  status?: number
}): Promise<API.MilestoneZb.Item> => request.patch(`/workbenchApi/projects/${projectID}/zb-milestones/${milestoneID}`, data)

export const deleteZbMilestoneApi = (projectID: number | string, milestoneID: number): Promise<void> =>
  request.delete(`/workbenchApi/projects/${projectID}/zb-milestones/${milestoneID}`)
